// Copyright (c) Zammo Inc.

export type LocaleMapping = {
  locale: string;
  display: string;
};

const localeMappings: LocaleMapping[] = [
  { locale: '', display: 'Invariant Language (Invariant Country)' },
  { locale: 'aa', display: 'Qafar' },
  { locale: 'aa-DJ', display: 'Qafar (Yabuuti)' },
  { locale: 'aa-ER', display: 'Qafar (Eretria)' },
  { locale: 'aa-ET', display: 'Qafar (Otobbia)' },
  { locale: 'af', display: 'Afrikaans' },
  { locale: 'af-NA', display: 'Afrikaans (Namibië)' },
  { locale: 'af-ZA', display: 'Afrikaans (South Africa)' },
  { locale: 'agq', display: 'Aghem' },
  { locale: 'agq-CM', display: 'Aghem (Kàmàlûŋ)' },
  { locale: 'ak', display: 'Akan' },
  { locale: 'ak-GH', display: 'Akan (Gaana)' },
  { locale: 'am', display: 'Amharic' },
  { locale: 'am-ET', display: 'Amharic (Ethiopia)' },
  { locale: 'ar', display: 'Arabic' },
  { locale: 'ar-001', display: 'العربية (العالم)' },
  { locale: 'ar-AE', display: 'Arabic (United Arab Emirates)' },
  { locale: 'ar-BH', display: 'Arabic (Bahrain)' },
  { locale: 'ar-DJ', display: 'العربية (جيبوتي)' },
  { locale: 'ar-DZ', display: 'Arabic (Algeria)' },
  { locale: 'ar-EG', display: 'Arabic (Egypt)' },
  { locale: 'ar-ER', display: 'العربية (إريتريا)' },
  { locale: 'ar-IL', display: 'العربية (إسرائيل)' },
  { locale: 'ar-IQ', display: 'Arabic (Iraq)' },
  { locale: 'ar-JO', display: 'Arabic (Jordan)' },
  { locale: 'ar-KM', display: 'العربية (جزر القمر)' },
  { locale: 'ar-KW', display: 'Arabic (Kuwait)' },
  { locale: 'ar-LB', display: 'Arabic (Lebanon)' },
  { locale: 'ar-LY', display: 'Arabic (Libya)' },
  { locale: 'ar-MA', display: 'Arabic (Morocco)' },
  { locale: 'ar-MR', display: 'العربية (موريتانيا)' },
  { locale: 'ar-OM', display: 'Arabic (Oman)' },
  { locale: 'ar-PS', display: 'العربية (السلطة الفلسطينية)' },
  { locale: 'ar-QA', display: 'Arabic (Qatar)' },
  { locale: 'ar-SA', display: 'Arabic (Saudi Arabia)' },
  { locale: 'ar-SD', display: 'العربية (السودان)' },
  { locale: 'ar-SO', display: 'العربية (الصومال)' },
  { locale: 'ar-SS', display: 'العربية (جنوب السودان)' },
  { locale: 'ar-SY', display: 'Arabic (Syria)' },
  { locale: 'ar-TD', display: 'العربية (تشاد)' },
  { locale: 'ar-TN', display: 'Arabic (Tunisia)' },
  { locale: 'ar-YE', display: 'Arabic (Yemen)' },
  { locale: 'arn', display: 'Mapuche' },
  { locale: 'arn-CL', display: 'Mapuche (Chile)' },
  { locale: 'as', display: 'Assamese' },
  { locale: 'as-IN', display: 'Assamese (India)' },
  { locale: 'asa', display: 'Kipare' },
  { locale: 'asa-TZ', display: 'Kipare (Tadhania)' },
  { locale: 'ast', display: 'asturianu' },
  { locale: 'ast-ES', display: 'asturianu (España)' },
  { locale: 'az', display: 'Azerbaijani' },
  { locale: 'az-Cyrl', display: 'Azerbaijani (Cyrillic)' },
  { locale: 'az-Cyrl-AZ', display: 'Azerbaijani (Cyrillic, Azerbaijan)' },
  { locale: 'az-Latn', display: 'Azerbaijani (Latin)' },
  { locale: 'az-Latn-AZ', display: 'Azerbaijani (Latin, Azerbaijan)' },
  { locale: 'ba', display: 'Bashkir' },
  { locale: 'ba-RU', display: 'Bashkir (Russia)' },
  { locale: 'bas', display: 'Ɓàsàa' },
  { locale: 'bas-CM', display: 'Ɓàsàa (Kàmɛ̀rûn)' },
  { locale: 'be', display: 'Belarusian' },
  { locale: 'be-BY', display: 'Belarusian (Belarus)' },
  { locale: 'bem', display: 'Ichibemba' },
  { locale: 'bem-ZM', display: 'Ichibemba (Zambia)' },
  { locale: 'bez', display: 'Hibena' },
  { locale: 'bez-TZ', display: 'Hibena (Hutanzania)' },
  { locale: 'bg', display: 'Bulgarian' },
  { locale: 'bg-BG', display: 'Bulgarian (Bulgaria)' },
  { locale: 'bin', display: 'Edo' },
  { locale: 'bin-NG', display: 'Edo (Nigeria)' },
  { locale: 'bm', display: 'bamanakan' },
  { locale: 'bm-Latn', display: 'bamanakan' },
  { locale: 'bm-Latn-ML', display: 'bamanakan (Mali)' },
  { locale: 'bn', display: 'Bangla' },
  { locale: 'bn-BD', display: 'Bangla (Bangladesh)' },
  { locale: 'bn-IN', display: 'Bengali (India)' },
  { locale: 'bo', display: 'Tibetan' },
  { locale: 'bo-CN', display: 'Tibetan (China)' },
  { locale: 'bo-IN', display: 'བོད་སྐད་ (རྒྱ་གར་)' },
  { locale: 'br', display: 'Breton' },
  { locale: 'br-FR', display: 'Breton (France)' },
  { locale: 'brx', display: 'बड़ो' },
  { locale: 'brx-IN', display: 'बड़ो (भारत)' },
  { locale: 'bs', display: 'Bosnian' },
  { locale: 'bs-Cyrl', display: 'Bosnian (Cyrillic)' },
  { locale: 'bs-Cyrl-BA', display: 'Bosnian (Cyrillic, Bosnia and Herzegovina)' },
  { locale: 'bs-Latn', display: 'Bosnian (Latin)' },
  { locale: 'bs-Latn-BA', display: 'Bosnian (Latin, Bosnia & Herzegovina)' },
  { locale: 'byn', display: 'ብሊን' },
  { locale: 'byn-ER', display: 'ብሊን (ኤርትራ)' },
  { locale: 'ca', display: 'Catalan' },
  { locale: 'ca-AD', display: 'català (Andorra)' },
  { locale: 'ca-ES', display: 'Catalan (Catalan)' },
  { locale: 'ca-ES-valencia', display: 'Valencian (Spain)' },
  { locale: 'ca-FR', display: 'català (França)' },
  { locale: 'ca-IT', display: 'català (Itàlia)' },
  { locale: 'ccp', display: '𑄌𑄋𑄴𑄟𑄳𑄦' },
  { locale: 'ccp-Cakm', display: '𑄌𑄋𑄴𑄟𑄳𑄦' },
  { locale: 'ccp-Cakm-BD', display: '𑄌𑄋𑄴𑄟𑄳𑄦 (𑄝𑄁𑄣𑄘𑄬𑄌𑄴)' },
  { locale: 'ccp-Cakm-IN', display: '𑄌𑄋𑄴𑄟𑄳𑄦 (𑄞𑄢𑄧𑄖𑄴)' },
  { locale: 'ce', display: 'нохчийн' },
  { locale: 'ce-RU', display: 'нохчийн (Росси)' },
  { locale: 'ceb', display: 'Cebuano' },
  { locale: 'ceb-Latn', display: 'Cebuano' },
  { locale: 'ceb-Latn-PH', display: 'Cebuano (Pilipinas)' },
  { locale: 'cgg', display: 'Rukiga' },
  { locale: 'cgg-UG', display: 'Rukiga (Uganda)' },
  { locale: 'chr', display: 'Cherokee' },
  { locale: 'chr-Cher', display: 'Cherokee' },
  { locale: 'chr-Cher-US', display: 'Cherokee (Cherokee, United States)' },
  { locale: 'co', display: 'Corsican' },
  { locale: 'co-FR', display: 'Corsican (France)' },
  { locale: 'cs', display: 'Czech' },
  { locale: 'cs-CZ', display: 'Czech (Czech Republic)' },
  { locale: 'cu', display: 'церковнослове́нскїй' },
  { locale: 'cu-RU', display: 'церковнослове́нскїй (рѡссі́а)' },
  { locale: 'cy', display: 'Welsh' },
  { locale: 'cy-GB', display: 'Welsh (United Kingdom)' },
  { locale: 'da', display: 'Danish' },
  { locale: 'da-DK', display: 'Danish (Denmark)' },
  { locale: 'da-GL', display: 'dansk (Grønland)' },
  { locale: 'dav', display: 'Kitaita' },
  { locale: 'dav-KE', display: 'Kitaita (Kenya)' },
  { locale: 'de', display: 'German' },
  { locale: 'de-AT', display: 'German (Austria)' },
  { locale: 'de-BE', display: 'Deutsch (Belgien)' },
  { locale: 'de-CH', display: 'German (Switzerland)' },
  { locale: 'de-DE', display: 'German (Germany)' },
  { locale: 'de-IT', display: 'Deutsch (Italien)' },
  { locale: 'de-LI', display: 'German (Liechtenstein)' },
  { locale: 'de-LU', display: 'German (Luxembourg)' },
  { locale: 'dje', display: 'Zarmaciine' },
  { locale: 'dje-NE', display: 'Zarmaciine (Nižer)' },
  { locale: 'dsb', display: 'Lower Sorbian' },
  { locale: 'dsb-DE', display: 'Lower Sorbian (Germany)' },
  { locale: 'dua', display: 'duálá' },
  { locale: 'dua-CM', display: 'duálá (Cameroun)' },
  { locale: 'dv', display: 'Divehi' },
  { locale: 'dv-MV', display: 'Divehi (Maldives)' },
  { locale: 'dyo', display: 'joola' },
  { locale: 'dyo-SN', display: 'joola (Senegal)' },
  { locale: 'dz', display: 'རྫོང་ཁ' },
  { locale: 'dz-BT', display: 'Dzongkha (Bhutan)' },
  { locale: 'ebu', display: 'Kĩembu' },
  { locale: 'ebu-KE', display: 'Kĩembu (Kenya)' },
  { locale: 'ee', display: 'Eʋegbe' },
  { locale: 'ee-GH', display: 'Eʋegbe (Ghana nutome)' },
  { locale: 'ee-TG', display: 'Eʋegbe (Togo nutome)' },
  { locale: 'el', display: 'Greek' },
  { locale: 'el-CY', display: 'Ελληνικά (Κύπρος)' },
  { locale: 'el-GR', display: 'Greek (Greece)' },
  { locale: 'en', display: 'English' },
  { locale: 'en-001', display: 'English (World)' },
  { locale: 'en-029', display: 'English (Caribbean)' },
  { locale: 'en-150', display: 'English (Europe)' },
  { locale: 'en-AE', display: 'English (United Arab Emirates)' },
  { locale: 'en-AG', display: 'English (Antigua & Barbuda)' },
  { locale: 'en-AI', display: 'English (Anguilla)' },
  { locale: 'en-AS', display: 'English (American Samoa)' },
  { locale: 'en-AT', display: 'English (Austria)' },
  { locale: 'en-AU', display: 'English (Australia)' },
  { locale: 'en-BB', display: 'English (Barbados)' },
  { locale: 'en-BE', display: 'English (Belgium)' },
  { locale: 'en-BI', display: 'English (Burundi)' },
  { locale: 'en-BM', display: 'English (Bermuda)' },
  { locale: 'en-BS', display: 'English (Bahamas)' },
  { locale: 'en-BW', display: 'English (Botswana)' },
  { locale: 'en-BZ', display: 'English (Belize)' },
  { locale: 'en-CA', display: 'English (Canada)' },
  { locale: 'en-CC', display: 'English (Cocos (Keeling) Islands)' },
  { locale: 'en-CH', display: 'English (Switzerland)' },
  { locale: 'en-CK', display: 'English (Cook Islands)' },
  { locale: 'en-CM', display: 'English (Cameroon)' },
  { locale: 'en-CX', display: 'English (Christmas Island)' },
  { locale: 'en-CY', display: 'English (Cyprus)' },
  { locale: 'en-DE', display: 'English (Germany)' },
  { locale: 'en-DK', display: 'English (Denmark)' },
  { locale: 'en-DM', display: 'English (Dominica)' },
  { locale: 'en-ER', display: 'English (Eritrea)' },
  { locale: 'en-FI', display: 'English (Finland)' },
  { locale: 'en-FJ', display: 'English (Fiji)' },
  { locale: 'en-FK', display: 'English (Falkland Islands)' },
  { locale: 'en-FM', display: 'English (Micronesia)' },
  { locale: 'en-GB', display: 'English (United Kingdom)' },
  { locale: 'en-GD', display: 'English (Grenada)' },
  { locale: 'en-GG', display: 'English (Guernsey)' },
  { locale: 'en-GH', display: 'English (Ghana)' },
  { locale: 'en-GI', display: 'English (Gibraltar)' },
  { locale: 'en-GM', display: 'English (Gambia)' },
  { locale: 'en-GU', display: 'English (Guam)' },
  { locale: 'en-GY', display: 'English (Guyana)' },
  { locale: 'en-HK', display: 'English (Hong Kong SAR)' },
  { locale: 'en-ID', display: 'English (Indonesia)' },
  { locale: 'en-IE', display: 'English (Ireland)' },
  { locale: 'en-IL', display: 'English (Israel)' },
  { locale: 'en-IM', display: 'English (Isle of Man)' },
  { locale: 'en-IN', display: 'English (India)' },
  { locale: 'en-IO', display: 'English (British Indian Ocean Territory)' },
  { locale: 'en-JE', display: 'English (Jersey)' },
  { locale: 'en-JM', display: 'English (Jamaica)' },
  { locale: 'en-KE', display: 'English (Kenya)' },
  { locale: 'en-KI', display: 'English (Kiribati)' },
  { locale: 'en-KN', display: 'English (St. Kitts & Nevis)' },
  { locale: 'en-KY', display: 'English (Cayman Islands)' },
  { locale: 'en-LC', display: 'English (St. Lucia)' },
  { locale: 'en-LR', display: 'English (Liberia)' },
  { locale: 'en-LS', display: 'English (Lesotho)' },
  { locale: 'en-MG', display: 'English (Madagascar)' },
  { locale: 'en-MH', display: 'English (Marshall Islands)' },
  { locale: 'en-MO', display: 'English (Macao SAR)' },
  { locale: 'en-MP', display: 'English (Northern Mariana Islands)' },
  { locale: 'en-MS', display: 'English (Montserrat)' },
  { locale: 'en-MT', display: 'English (Malta)' },
  { locale: 'en-MU', display: 'English (Mauritius)' },
  { locale: 'en-MW', display: 'English (Malawi)' },
  { locale: 'en-MY', display: 'English (Malaysia)' },
  { locale: 'en-NA', display: 'English (Namibia)' },
  { locale: 'en-NF', display: 'English (Norfolk Island)' },
  { locale: 'en-NG', display: 'English (Nigeria)' },
  { locale: 'en-NL', display: 'English (Netherlands)' },
  { locale: 'en-NR', display: 'English (Nauru)' },
  { locale: 'en-NU', display: 'English (Niue)' },
  { locale: 'en-NZ', display: 'English (New Zealand)' },
  { locale: 'en-PG', display: 'English (Papua New Guinea)' },
  { locale: 'en-PH', display: 'English (Philippines)' },
  { locale: 'en-PK', display: 'English (Pakistan)' },
  { locale: 'en-PN', display: 'English (Pitcairn Islands)' },
  { locale: 'en-PR', display: 'English (Puerto Rico)' },
  { locale: 'en-PW', display: 'English (Palau)' },
  { locale: 'en-RW', display: 'English (Rwanda)' },
  { locale: 'en-SB', display: 'English (Solomon Islands)' },
  { locale: 'en-SC', display: 'English (Seychelles)' },
  { locale: 'en-SD', display: 'English (Sudan)' },
  { locale: 'en-SE', display: 'English (Sweden)' },
  { locale: 'en-SG', display: 'English (Singapore)' },
  { locale: 'en-SH', display: 'English (St Helena, Ascension, Tristan da Cunha)' },
  { locale: 'en-SI', display: 'English (Slovenia)' },
  { locale: 'en-SL', display: 'English (Sierra Leone)' },
  { locale: 'en-SS', display: 'English (South Sudan)' },
  { locale: 'en-SX', display: 'English (Sint Maarten)' },
  { locale: 'en-SZ', display: 'English (Eswatini)' },
  { locale: 'en-TC', display: 'English (Turks & Caicos Islands)' },
  { locale: 'en-TK', display: 'English (Tokelau)' },
  { locale: 'en-TO', display: 'English (Tonga)' },
  { locale: 'en-TT', display: 'English (Trinidad & Tobago)' },
  { locale: 'en-TV', display: 'English (Tuvalu)' },
  { locale: 'en-TZ', display: 'English (Tanzania)' },
  { locale: 'en-UG', display: 'English (Uganda)' },
  { locale: 'en-UM', display: 'English (U.S. Outlying Islands)' },
  { locale: 'en-US', display: 'English (United States)' },
  { locale: 'en-VC', display: 'English (St. Vincent & Grenadines)' },
  { locale: 'en-VG', display: 'English (British Virgin Islands)' },
  { locale: 'en-VI', display: 'English (U.S. Virgin Islands)' },
  { locale: 'en-VU', display: 'English (Vanuatu)' },
  { locale: 'en-WS', display: 'English (Samoa)' },
  { locale: 'en-ZA', display: 'English (South Africa)' },
  { locale: 'en-ZM', display: 'English (Zambia)' },
  { locale: 'en-ZW', display: 'English (Zimbabwe)' },
  { locale: 'eo', display: 'esperanto' },
  { locale: 'eo-001', display: 'esperanto (Mondo)' },
  { locale: 'es', display: 'Spanish' },
  { locale: 'es-419', display: 'Spanish (Latin America)' },
  { locale: 'es-AR', display: 'Spanish (Argentina)' },
  { locale: 'es-BO', display: 'Spanish (Bolivia)' },
  { locale: 'es-BR', display: 'español (Brasil)' },
  { locale: 'es-BZ', display: 'español (Belice)' },
  { locale: 'es-CL', display: 'Spanish (Chile)' },
  { locale: 'es-CO', display: 'Spanish (Colombia)' },
  { locale: 'es-CR', display: 'Spanish (Costa Rica)' },
  { locale: 'es-CU', display: 'Spanish (Cuba)' },
  { locale: 'es-DO', display: 'Spanish (Dominican Republic)' },
  { locale: 'es-EC', display: 'Spanish (Ecuador)' },
  { locale: 'es-ES', display: 'Spanish (Spain, International Sort)' },
  { locale: 'es-GQ', display: 'español (Guinea Ecuatorial)' },
  { locale: 'es-GT', display: 'Spanish (Guatemala)' },
  { locale: 'es-HN', display: 'Spanish (Honduras)' },
  { locale: 'es-MX', display: 'Spanish (Mexico)' },
  { locale: 'es-NI', display: 'Spanish (Nicaragua)' },
  { locale: 'es-PA', display: 'Spanish (Panama)' },
  { locale: 'es-PE', display: 'Spanish (Peru)' },
  { locale: 'es-PH', display: 'español (Filipinas)' },
  { locale: 'es-PR', display: 'Spanish (Puerto Rico)' },
  { locale: 'es-PY', display: 'Spanish (Paraguay)' },
  { locale: 'es-SV', display: 'Spanish (El Salvador)' },
  { locale: 'es-US', display: 'Spanish (United States)' },
  { locale: 'es-UY', display: 'Spanish (Uruguay)' },
  { locale: 'es-VE', display: 'Spanish (Venezuela)' },
  { locale: 'et', display: 'Estonian' },
  { locale: 'et-EE', display: 'Estonian (Estonia)' },
  { locale: 'eu', display: 'Basque' },
  { locale: 'eu-ES', display: 'Basque (Basque)' },
  { locale: 'ewo', display: 'ewondo' },
  { locale: 'ewo-CM', display: 'ewondo (Kamərún)' },
  { locale: 'fa', display: 'Persian' },
  { locale: 'fa-IR', display: 'Persian (Iran)' },
  { locale: 'ff', display: 'Fulah (Latin)' },
  { locale: 'ff-Latn', display: 'Fulah (Latin)' },
  { locale: 'ff-Latn-BF', display: 'Pulaar (Burkibaa Faaso)' },
  { locale: 'ff-Latn-CM', display: 'Pulaar (Kameruun)' },
  { locale: 'ff-Latn-GH', display: 'Pulaar (Ganaa)' },
  { locale: 'ff-Latn-GM', display: 'Pulaar (Gammbi)' },
  { locale: 'ff-Latn-GN', display: 'Pulaar (Gine)' },
  { locale: 'ff-Latn-GW', display: 'Pulaar (Gine-Bisaawo)' },
  { locale: 'ff-Latn-LR', display: 'Pulaar (Liberiyaa)' },
  { locale: 'ff-Latn-MR', display: 'Pulaar (Muritani)' },
  { locale: 'ff-Latn-NE', display: 'Pulaar (Nijeer)' },
  { locale: 'ff-Latn-NG', display: 'Fulah (Latin, Nigeria)' },
  { locale: 'ff-Latn-SL', display: 'Pulaar (Seraa liyon)' },
  { locale: 'ff-Latn-SN', display: 'Fulah (Latin, Senegal)' },
  { locale: 'fi', display: 'Finnish' },
  { locale: 'fi-FI', display: 'Finnish (Finland)' },
  { locale: 'fil', display: 'Filipino' },
  { locale: 'fil-PH', display: 'Filipino (Philippines)' },
  { locale: 'fo', display: 'Faroese' },
  { locale: 'fo-DK', display: 'føroyskt (Danmark)' },
  { locale: 'fo-FO', display: 'Faroese (Faroe Islands)' },
  { locale: 'fr', display: 'French' },
  { locale: 'fr-029', display: 'French (Caribbean)' },
  { locale: 'fr-BE', display: 'French (Belgium)' },
  { locale: 'fr-BF', display: 'français (Burkina Faso)' },
  { locale: 'fr-BI', display: 'français (Burundi)' },
  { locale: 'fr-BJ', display: 'français (Bénin)' },
  { locale: 'fr-BL', display: 'français (Saint-Barthélemy)' },
  { locale: 'fr-CA', display: 'French (Canada)' },
  { locale: 'fr-CD', display: 'French Congo (DRC)' },
  { locale: 'fr-CF', display: 'français (République centrafricaine)' },
  { locale: 'fr-CG', display: 'français (Congo)' },
  { locale: 'fr-CH', display: 'French (Switzerland)' },
  { locale: 'fr-CI', display: 'French (Côte d’Ivoire)' },
  { locale: 'fr-CM', display: 'French (Cameroon)' },
  { locale: 'fr-DJ', display: 'français (Djibouti)' },
  { locale: 'fr-DZ', display: 'français (Algérie)' },
  { locale: 'fr-FR', display: 'French (France)' },
  { locale: 'fr-GA', display: 'français (Gabon)' },
  { locale: 'fr-GF', display: 'français (Guyane française)' },
  { locale: 'fr-GN', display: 'français (Guinée)' },
  { locale: 'fr-GP', display: 'français (Guadeloupe)' },
  { locale: 'fr-GQ', display: 'français (Guinée équatoriale)' },
  { locale: 'fr-HT', display: 'French (Haiti)' },
  { locale: 'fr-KM', display: 'français (Comores)' },
  { locale: 'fr-LU', display: 'French (Luxembourg)' },
  { locale: 'fr-MA', display: 'French (Morocco)' },
  { locale: 'fr-MC', display: 'French (Monaco)' },
  { locale: 'fr-MF', display: 'français (Saint-Martin)' },
  { locale: 'fr-MG', display: 'français (Madagascar)' },
  { locale: 'fr-ML', display: 'French (Mali)' },
  { locale: 'fr-MQ', display: 'français (Martinique)' },
  { locale: 'fr-MR', display: 'français (Mauritanie)' },
  { locale: 'fr-MU', display: 'français (Maurice)' },
  { locale: 'fr-NC', display: 'français (Nouvelle-Calédonie)' },
  { locale: 'fr-NE', display: 'français (Niger)' },
  { locale: 'fr-PF', display: 'français (Polynésie française)' },
  { locale: 'fr-PM', display: 'français (Saint-Pierre-et-Miquelon)' },
  { locale: 'fr-RE', display: 'French (Réunion)' },
  { locale: 'fr-RW', display: 'français (Rwanda)' },
  { locale: 'fr-SC', display: 'français (Seychelles)' },
  { locale: 'fr-SN', display: 'French (Senegal)' },
  { locale: 'fr-SY', display: 'français (Syrie)' },
  { locale: 'fr-TD', display: 'français (Tchad)' },
  { locale: 'fr-TG', display: 'français (Togo)' },
  { locale: 'fr-TN', display: 'français (Tunisie)' },
  { locale: 'fr-VU', display: 'français (Vanuatu)' },
  { locale: 'fr-WF', display: 'français (Wallis-et-Futuna)' },
  { locale: 'fr-YT', display: 'français (Mayotte)' },
  { locale: 'fur', display: 'furlan' },
  { locale: 'fur-IT', display: 'furlan (Italie)' },
  { locale: 'fy', display: 'Western Frisian' },
  { locale: 'fy-NL', display: 'Western Frisian (Netherlands)' },
  { locale: 'ga', display: 'Irish' },
  { locale: 'ga-IE', display: 'Irish (Ireland)' },
  { locale: 'gd', display: 'Scottish Gaelic' },
  { locale: 'gd-GB', display: 'Scottish Gaelic (United Kingdom)' },
  { locale: 'gl', display: 'Galician' },
  { locale: 'gl-ES', display: 'Galician (Galician)' },
  { locale: 'gn', display: 'Guarani' },
  { locale: 'gn-PY', display: 'Guarani (Paraguay)' },
  { locale: 'gsw', display: 'Swiss German' },
  { locale: 'gsw-CH', display: 'Schwiizertüütsch (Schwiiz)' },
  { locale: 'gsw-FR', display: 'Alsatian (France)' },
  { locale: 'gsw-LI', display: 'Schwiizertüütsch (Liächteschtäi)' },
  { locale: 'gu', display: 'Gujarati' },
  { locale: 'gu-IN', display: 'Gujarati (India)' },
  { locale: 'guz', display: 'Ekegusii' },
  { locale: 'guz-KE', display: 'Ekegusii (Kenya)' },
  { locale: 'gv', display: 'Gaelg' },
  { locale: 'gv-IM', display: 'Gaelg (Ellan Vannin)' },
  { locale: 'ha', display: 'Hausa' },
  { locale: 'ha-Latn', display: 'Hausa (Latin)' },
  { locale: 'ha-Latn-GH', display: 'Hausa (Gana)' },
  { locale: 'ha-Latn-NE', display: 'Hausa (Nijar)' },
  { locale: 'ha-Latn-NG', display: 'Hausa (Latin, Nigeria)' },
  { locale: 'haw', display: 'Hawaiian' },
  { locale: 'haw-US', display: 'Hawaiian (United States)' },
  { locale: 'he', display: 'Hebrew' },
  { locale: 'he-IL', display: 'Hebrew (Israel)' },
  { locale: 'hi', display: 'Hindi' },
  { locale: 'hi-IN', display: 'Hindi (India)' },
  { locale: 'hr', display: 'Croatian' },
  { locale: 'hr-BA', display: 'Croatian (Bosnia & Herzegovina)' },
  { locale: 'hr-HR', display: 'Croatian (Croatia)' },
  { locale: 'hsb', display: 'Upper Sorbian' },
  { locale: 'hsb-DE', display: 'Upper Sorbian (Germany)' },
  { locale: 'hu', display: 'Hungarian' },
  { locale: 'hu-HU', display: 'Hungarian (Hungary)' },
  { locale: 'hy', display: 'Armenian' },
  { locale: 'hy-AM', display: 'Armenian (Armenia)' },
  { locale: 'ia', display: 'interlingua' },
  { locale: 'ia-001', display: 'interlingua (Mundo)' },
  { locale: 'ibb', display: 'Ibibio' },
  { locale: 'ibb-NG', display: 'Ibibio (Nigeria)' },
  { locale: 'id', display: 'Indonesian' },
  { locale: 'id-ID', display: 'Indonesian (Indonesia)' },
  { locale: 'ig', display: 'Igbo' },
  { locale: 'ig-NG', display: 'Igbo (Nigeria)' },
  { locale: 'ii', display: 'Yi' },
  { locale: 'ii-CN', display: 'Yi (China)' },
  { locale: 'is', display: 'Icelandic' },
  { locale: 'is-IS', display: 'Icelandic (Iceland)' },
  { locale: 'it', display: 'Italian' },
  { locale: 'it-CH', display: 'Italian (Switzerland)' },
  { locale: 'it-IT', display: 'Italian (Italy)' },
  { locale: 'it-SM', display: 'italiano (San Marino)' },
  { locale: 'it-VA', display: 'italiano (Città del Vaticano)' },
  { locale: 'iu', display: 'Inuktitut' },
  { locale: 'iu-Cans', display: 'Inuktitut (Syllabics)' },
  { locale: 'iu-Cans-CA', display: 'Inuktitut (Syllabics, Canada)' },
  { locale: 'iu-Latn', display: 'Inuktitut (Latin)' },
  { locale: 'iu-Latn-CA', display: 'Inuktitut (Latin, Canada)' },
  { locale: 'ja', display: 'Japanese' },
  { locale: 'ja-JP', display: 'Japanese (Japan)' },
  { locale: 'jgo', display: 'Ndaꞌa' },
  { locale: 'jgo-CM', display: 'Ndaꞌa (Kamɛlûn)' },
  { locale: 'jmc', display: 'Kimachame' },
  { locale: 'jmc-TZ', display: 'Kimachame (Tanzania)' },
  { locale: 'jv', display: 'Basa Jawa' },
  { locale: 'jv-Java', display: 'ꦧꦱꦗꦮ' },
  { locale: 'jv-Java-ID', display: 'ꦧꦱꦗꦮ (Indonesia)' },
  { locale: 'jv-Latn', display: 'Basa Jawa' },
  { locale: 'jv-Latn-ID', display: 'Basa Jawa (Indonesia)' },
  { locale: 'ka', display: 'Georgian' },
  { locale: 'ka-GE', display: 'Georgian (Georgia)' },
  { locale: 'kab', display: 'Taqbaylit' },
  { locale: 'kab-DZ', display: 'Taqbaylit (Lezzayer)' },
  { locale: 'kam', display: 'Kikamba' },
  { locale: 'kam-KE', display: 'Kikamba (Kenya)' },
  { locale: 'kde', display: 'Chimakonde' },
  { locale: 'kde-TZ', display: 'Chimakonde (Tanzania)' },
  { locale: 'kea', display: 'kabuverdianu' },
  { locale: 'kea-CV', display: 'kabuverdianu (Kabu Verdi)' },
  { locale: 'khq', display: 'Koyra ciini' },
  { locale: 'khq-ML', display: 'Koyra ciini (Maali)' },
  { locale: 'ki', display: 'Gikuyu' },
  { locale: 'ki-KE', display: 'Gikuyu (Kenya)' },
  { locale: 'kk', display: 'Kazakh' },
  { locale: 'kk-KZ', display: 'Kazakh (Kazakhstan)' },
  { locale: 'kkj', display: 'kakɔ' },
  { locale: 'kkj-CM', display: 'kakɔ (Kamɛrun)' },
  { locale: 'kl', display: 'Kalaallisut' },
  { locale: 'kl-GL', display: 'Kalaallisut (Greenland)' },
  { locale: 'kln', display: 'Kalenjin' },
  { locale: 'kln-KE', display: 'Kalenjin (Emetab Kenya)' },
  { locale: 'km', display: 'Khmer' },
  { locale: 'km-KH', display: 'Khmer (Cambodia)' },
  { locale: 'kn', display: 'Kannada' },
  { locale: 'kn-IN', display: 'Kannada (India)' },
  { locale: 'ko', display: 'Korean' },
  { locale: 'ko-KP', display: '한국어 (조선민주주의인민공화국)' },
  { locale: 'ko-KR', display: 'Korean (Korea)' },
  { locale: 'kok', display: 'Konkani' },
  { locale: 'kok-IN', display: 'Konkani (India)' },
  { locale: 'kr', display: 'Kanuri' },
  { locale: 'kr-Latn', display: 'Kanuri' },
  { locale: 'kr-Latn-NG', display: 'Kanuri (Nigeria)' },
  { locale: 'ks', display: 'Kashmiri' },
  { locale: 'ks-Arab', display: 'Kashmiri (Perso-Arabic)' },
  { locale: 'ks-Arab-IN', display: 'کٲشُر (اَربی)' },
  { locale: 'ks-Deva', display: 'कॉशुर' },
  { locale: 'ks-Deva-IN', display: 'Kashmiri (Devanagari)' },
  { locale: 'ksb', display: 'Kishambaa' },
  { locale: 'ksb-TZ', display: 'Kishambaa (Tanzania)' },
  { locale: 'ksf', display: 'rikpa' },
  { locale: 'ksf-CM', display: 'rikpa (kamɛrún)' },
  { locale: 'ksh', display: 'Kölsch' },
  { locale: 'ksh-DE', display: 'Kölsch (Doütschland)' },
  { locale: 'ku', display: 'Central Kurdish' },
  { locale: 'ku-Arab', display: 'Central Kurdish' },
  { locale: 'ku-Arab-IQ', display: 'Central Kurdish (Iraq)' },
  { locale: 'ku-Arab-IR', display: 'کوردی (ئێران)' },
  { locale: 'kw', display: 'kernewek' },
  { locale: 'kw-GB', display: 'kernewek (Rywvaneth Unys)' },
  { locale: 'ky', display: 'Kyrgyz' },
  { locale: 'ky-KG', display: 'Kyrgyz (Kyrgyzstan)' },
  { locale: 'la', display: 'Latin' },
  { locale: 'la-001', display: 'Latin (World)' },
  { locale: 'lag', display: 'Kɨlaangi' },
  { locale: 'lag-TZ', display: 'Kɨlaangi (Taansanía)' },
  { locale: 'lb', display: 'Luxembourgish' },
  { locale: 'lb-LU', display: 'Luxembourgish (Luxembourg)' },
  { locale: 'lg', display: 'Luganda' },
  { locale: 'lg-UG', display: 'Luganda (Yuganda)' },
  { locale: 'lkt', display: 'Lakȟólʼiyapi' },
  { locale: 'lkt-US', display: 'Lakȟólʼiyapi (Mílahaŋska Tȟamákȟočhe)' },
  { locale: 'ln', display: 'lingála' },
  { locale: 'ln-AO', display: 'lingála (Angóla)' },
  { locale: 'ln-CD', display: 'lingála (Republíki ya Kongó Demokratíki)' },
  { locale: 'ln-CF', display: 'lingála (Repibiki ya Afríka ya Káti)' },
  { locale: 'ln-CG', display: 'lingála (Kongo)' },
  { locale: 'lo', display: 'Lao' },
  { locale: 'lo-LA', display: 'Lao (Laos)' },
  { locale: 'lrc', display: 'لۊری شومالی' },
  { locale: 'lrc-IQ', display: 'لۊری شومالی (Iraq)' },
  { locale: 'lrc-IR', display: 'لۊری شومالی (Iran)' },
  { locale: 'lt', display: 'Lithuanian' },
  { locale: 'lt-LT', display: 'Lithuanian (Lithuania)' },
  { locale: 'lu', display: 'Tshiluba' },
  { locale: 'lu-CD', display: 'Tshiluba (Ditunga wa Kongu)' },
  { locale: 'luo', display: 'Dholuo' },
  { locale: 'luo-KE', display: 'Dholuo (Kenya)' },
  { locale: 'luy', display: 'Luluhia' },
  { locale: 'luy-KE', display: 'Luluhia (Kenya)' },
  { locale: 'lv', display: 'Latvian' },
  { locale: 'lv-LV', display: 'Latvian (Latvia)' },
  { locale: 'mas', display: 'Maa' },
  { locale: 'mas-KE', display: 'Maa (Kenya)' },
  { locale: 'mas-TZ', display: 'Maa (Tansania)' },
  { locale: 'mer', display: 'Kĩmĩrũ' },
  { locale: 'mer-KE', display: 'Kĩmĩrũ (Kenya)' },
  { locale: 'mfe', display: 'kreol morisien' },
  { locale: 'mfe-MU', display: 'kreol morisien (Moris)' },
  { locale: 'mg', display: 'Malagasy' },
  { locale: 'mg-MG', display: 'Malagasy (Madagasikara)' },
  { locale: 'mgh', display: 'Makua' },
  { locale: 'mgh-MZ', display: 'Makua (Umozambiki)' },
  { locale: 'mgo', display: 'metaʼ' },
  { locale: 'mgo-CM', display: 'metaʼ (Kamalun)' },
  { locale: 'mi', display: 'Maori' },
  { locale: 'mi-NZ', display: 'Maori (New Zealand)' },
  { locale: 'mk', display: 'Macedonian' },
  { locale: 'mk-MK', display: 'Macedonian (North Macedonia)' },
  { locale: 'ml', display: 'Malayalam' },
  { locale: 'ml-IN', display: 'Malayalam (India)' },
  { locale: 'mn', display: 'Mongolian' },
  { locale: 'mn-Cyrl', display: 'Mongolian' },
  { locale: 'mn-MN', display: 'Mongolian (Mongolia)' },
  { locale: 'mn-Mong', display: 'Mongolian (Traditional Mongolian)' },
  { locale: 'mn-Mong-CN', display: 'Mongolian (Traditional Mongolian, China)' },
  { locale: 'mn-Mong-MN', display: 'Mongolian (Traditional Mongolian, Mongolia)' },
  { locale: 'mni', display: 'Manipuri' },
  { locale: 'mni-IN', display: 'Manipuri (India)' },
  { locale: 'moh', display: 'Mohawk' },
  { locale: 'moh-CA', display: 'Mohawk (Mohawk)' },
  { locale: 'mr', display: 'Marathi' },
  { locale: 'mr-IN', display: 'Marathi (India)' },
  { locale: 'ms', display: 'Malay' },
  { locale: 'ms-BN', display: 'Malay (Brunei)' },
  { locale: 'ms-MY', display: 'Malay (Malaysia)' },
  { locale: 'ms-SG', display: 'Melayu (Singapura)' },
  { locale: 'mt', display: 'Maltese' },
  { locale: 'mt-MT', display: 'Maltese (Malta)' },
  { locale: 'mua', display: 'MUNDAŊ' },
  { locale: 'mua-CM', display: 'MUNDAŊ (kameruŋ)' },
  { locale: 'my', display: 'Burmese' },
  { locale: 'my-MM', display: 'Burmese (Myanmar)' },
  { locale: 'mzn', display: 'مازرونی' },
  { locale: 'mzn-IR', display: 'مازرونی (ایران)' },
  { locale: 'naq', display: 'Khoekhoegowab' },
  { locale: 'naq-NA', display: 'Khoekhoegowab (Namibiab)' },
  { locale: 'nb', display: 'Norwegian Bokmål' },
  { locale: 'nb-NO', display: 'Norwegian Bokmål (Norway)' },
  { locale: 'nb-SJ', display: 'norsk bokmål (Svalbard og Jan Mayen)' },
  { locale: 'nd', display: 'isiNdebele' },
  { locale: 'nd-ZW', display: 'isiNdebele (Zimbabwe)' },
  { locale: 'nds', display: 'Neddersass’sch' },
  { locale: 'nds-DE', display: 'Neddersass’sch (Düütschland)' },
  { locale: 'nds-NL', display: 'Neddersass’sch (Nedderlannen)' },
  { locale: 'ne', display: 'Nepali' },
  { locale: 'ne-IN', display: 'Nepali (India)' },
  { locale: 'ne-NP', display: 'Nepali (Nepal)' },
  { locale: 'nl', display: 'Dutch' },
  { locale: 'nl-AW', display: 'Nederlands (Aruba)' },
  { locale: 'nl-BE', display: 'Dutch (Belgium)' },
  { locale: 'nl-BQ', display: 'Nederlands (Bonaire, Sint Eustatius en Saba)' },
  { locale: 'nl-CW', display: 'Nederlands (Curaçao)' },
  { locale: 'nl-NL', display: 'Dutch (Netherlands)' },
  { locale: 'nl-SR', display: 'Nederlands (Suriname)' },
  { locale: 'nl-SX', display: 'Nederlands (Sint-Maarten)' },
  { locale: 'nmg', display: 'Kwasio' },
  { locale: 'nmg-CM', display: 'Kwasio (Kamerun)' },
  { locale: 'nn', display: 'Norwegian Nynorsk' },
  { locale: 'nn-NO', display: 'Norwegian Nynorsk (Norway)' },
  { locale: 'nnh', display: 'Shwóŋò ngiembɔɔn' },
  { locale: 'nnh-CM', display: 'Shwóŋò ngiembɔɔn (Kàmalûm)' },
  { locale: 'no', display: 'Norwegian' },
  { locale: 'nqo', display: 'ߒߞߏ' },
  { locale: 'nqo-GN', display: 'ߒߞߏ (ߖߌ߬ߣߍ߬ ߞߊ߲ߓߍ߲)' },
  { locale: 'nr', display: 'isiNdebele' },
  { locale: 'nr-ZA', display: 'isiNdebele (South Africa)' },
  { locale: 'nso', display: 'Sesotho sa Leboa' },
  { locale: 'nso-ZA', display: 'Sesotho sa Leboa (South Africa)' },
  { locale: 'nus', display: 'Thok Nath' },
  { locale: 'nus-SS', display: 'Thok Nath (South Sudan)' },
  { locale: 'nyn', display: 'Runyankore' },
  { locale: 'nyn-UG', display: 'Runyankore (Uganda)' },
  { locale: 'oc', display: 'Occitan' },
  { locale: 'oc-FR', display: 'Occitan (France)' },
  { locale: 'om', display: 'Oromo' },
  { locale: 'om-ET', display: 'Oromo (Ethiopia)' },
  { locale: 'om-KE', display: 'Oromoo (Keeniyaa)' },
  { locale: 'or', display: 'Odia' },
  { locale: 'or-IN', display: 'Odia (India)' },
  { locale: 'os', display: 'ирон' },
  { locale: 'os-GE', display: 'ирон (Гуырдзыстон)' },
  { locale: 'os-RU', display: 'ирон (Уӕрӕсе)' },
  { locale: 'pa', display: 'Punjabi' },
  { locale: 'pa-Arab', display: 'Punjabi' },
  { locale: 'pa-Arab-PK', display: 'Punjabi (Pakistan)' },
  { locale: 'pa-Guru', display: 'ਪੰਜਾਬੀ' },
  { locale: 'pa-IN', display: 'Punjabi (India)' },
  { locale: 'pap', display: 'Papiamento' },
  { locale: 'pap-029', display: 'Papiamento (Caribbean)' },
  { locale: 'pl', display: 'Polish' },
  { locale: 'pl-PL', display: 'Polish (Poland)' },
  { locale: 'prg', display: 'prūsiskan' },
  { locale: 'prg-001', display: 'prūsiskan (swītai)' },
  { locale: 'prs', display: 'Dari' },
  { locale: 'prs-AF', display: 'Dari (Afghanistan)' },
  { locale: 'ps', display: 'Pashto' },
  { locale: 'ps-AF', display: 'Pashto (Afghanistan)' },
  { locale: 'ps-PK', display: 'پښتو (پاکستان)' },
  { locale: 'pt', display: 'Portuguese' },
  { locale: 'pt-AO', display: 'português (Angola)' },
  { locale: 'pt-BR', display: 'Portuguese (Brazil)' },
  { locale: 'pt-CH', display: 'português (Suíça)' },
  { locale: 'pt-CV', display: 'português (Cabo Verde)' },
  { locale: 'pt-GQ', display: 'português (Guiné Equatorial)' },
  { locale: 'pt-GW', display: 'português (Guiné-Bissau)' },
  { locale: 'pt-LU', display: 'português (Luxemburgo)' },
  { locale: 'pt-MO', display: 'português (RAE de Macau)' },
  { locale: 'pt-MZ', display: 'português (Moçambique)' },
  { locale: 'pt-PT', display: 'Portuguese (Portugal)' },
  { locale: 'pt-ST', display: 'português (São Tomé e Príncipe)' },
  { locale: 'pt-TL', display: 'português (Timor-Leste)' },
  { locale: 'quc', display: "K'iche'" },
  { locale: 'quc-Latn', display: "K'iche'" },
  { locale: 'quc-Latn-GT', display: 'K’iche’ (Guatemala)' },
  { locale: 'quz', display: 'Quechua' },
  { locale: 'quz-BO', display: 'Quechua (Bolivia)' },
  { locale: 'quz-EC', display: 'Quechua (Ecuador)' },
  { locale: 'quz-PE', display: 'Quechua (Peru)' },
  { locale: 'rm', display: 'Romansh' },
  { locale: 'rm-CH', display: 'Romansh (Switzerland)' },
  { locale: 'rn', display: 'Ikirundi' },
  { locale: 'rn-BI', display: 'Ikirundi (Uburundi)' },
  { locale: 'ro', display: 'Romanian' },
  { locale: 'ro-MD', display: 'Romanian (Moldova)' },
  { locale: 'ro-RO', display: 'Romanian (Romania)' },
  { locale: 'rof', display: 'Kihorombo' },
  { locale: 'rof-TZ', display: 'Kihorombo (Tanzania)' },
  { locale: 'ru', display: 'Russian' },
  { locale: 'ru-BY', display: 'русский (Беларусь)' },
  { locale: 'ru-KG', display: 'русский (Киргизия)' },
  { locale: 'ru-KZ', display: 'русский (Казахстан)' },
  { locale: 'ru-MD', display: 'Russian (Moldova)' },
  { locale: 'ru-RU', display: 'Russian (Russia)' },
  { locale: 'ru-UA', display: 'русский (Украина)' },
  { locale: 'rw', display: 'Kinyarwanda' },
  { locale: 'rw-RW', display: 'Kinyarwanda (Rwanda)' },
  { locale: 'rwk', display: 'Kiruwa' },
  { locale: 'rwk-TZ', display: 'Kiruwa (Tanzania)' },
  { locale: 'sa', display: 'Sanskrit' },
  { locale: 'sa-IN', display: 'Sanskrit (India)' },
  { locale: 'sah', display: 'Sakha' },
  { locale: 'sah-RU', display: 'Sakha (Russia)' },
  { locale: 'saq', display: 'Kisampur' },
  { locale: 'saq-KE', display: 'Kisampur (Kenya)' },
  { locale: 'sbp', display: 'Ishisangu' },
  { locale: 'sbp-TZ', display: 'Ishisangu (Tansaniya)' },
  { locale: 'sd', display: 'Sindhi' },
  { locale: 'sd-Arab', display: 'Sindhi' },
  { locale: 'sd-Arab-PK', display: 'Sindhi (Pakistan)' },
  { locale: 'sd-Deva', display: 'सिन्धी' },
  { locale: 'sd-Deva-IN', display: 'Sindhi (Devanagari, India)' },
  { locale: 'se', display: 'Northern Sami' },
  { locale: 'se-FI', display: 'Sami, Northern (Finland)' },
  { locale: 'se-NO', display: 'Sami, Northern (Norway)' },
  { locale: 'se-SE', display: 'Sami, Northern (Sweden)' },
  { locale: 'seh', display: 'sena' },
  { locale: 'seh-MZ', display: 'sena (Moçambique)' },
  { locale: 'ses', display: 'Koyraboro senni' },
  { locale: 'ses-ML', display: 'Koyraboro senni (Maali)' },
  { locale: 'sg', display: 'Sängö' },
  { locale: 'sg-CF', display: 'Sängö (Ködörösêse tî Bêafrîka)' },
  { locale: 'shi', display: 'ⵜⴰⵛⵍⵃⵉⵜ' },
  { locale: 'shi-Latn', display: 'Tashelḥiyt' },
  { locale: 'shi-Latn-MA', display: 'Tashelḥiyt (lmɣrib)' },
  { locale: 'shi-Tfng', display: 'ⵜⴰⵛⵍⵃⵉⵜ' },
  { locale: 'shi-Tfng-MA', display: 'ⵜⴰⵛⵍⵃⵉⵜ (ⵍⵎⵖⵔⵉⴱ)' },
  { locale: 'si', display: 'Sinhala' },
  { locale: 'si-LK', display: 'Sinhala (Sri Lanka)' },
  { locale: 'sk', display: 'Slovak' },
  { locale: 'sk-SK', display: 'Slovak (Slovakia)' },
  { locale: 'sl', display: 'Slovenian' },
  { locale: 'sl-SI', display: 'Slovenian (Slovenia)' },
  { locale: 'sma', display: 'Sami (Southern)' },
  { locale: 'sma-NO', display: 'Sami, Southern (Norway)' },
  { locale: 'sma-SE', display: 'Sami, Southern (Sweden)' },
  { locale: 'smj', display: 'Sami (Lule)' },
  { locale: 'smj-NO', display: 'Sami, Lule (Norway)' },
  { locale: 'smj-SE', display: 'Sami, Lule (Sweden)' },
  { locale: 'smn', display: 'Sami (Inari)' },
  { locale: 'smn-FI', display: 'Sami, Inari (Finland)' },
  { locale: 'sms', display: 'Sami (Skolt)' },
  { locale: 'sms-FI', display: 'Sami, Skolt (Finland)' },
  { locale: 'sn', display: 'chiShona' },
  { locale: 'sn-Latn', display: 'chiShona (Latin)' },
  { locale: 'sn-Latn-ZW', display: 'chiShona (Zimbabwe)' },
  { locale: 'so', display: 'Somali' },
  { locale: 'so-DJ', display: 'Soomaali (Jabuuti)' },
  { locale: 'so-ET', display: 'Soomaali (Itoobiya)' },
  { locale: 'so-KE', display: 'Soomaali (Kenya)' },
  { locale: 'so-SO', display: 'Somali (Somalia)' },
  { locale: 'sq', display: 'Albanian' },
  { locale: 'sq-AL', display: 'Albanian (Albania)' },
  { locale: 'sq-MK', display: 'shqip (Maqedonia e Veriut)' },
  { locale: 'sq-XK', display: 'shqip (Kosovë)' },
  { locale: 'sr', display: 'Serbian' },
  { locale: 'sr-Cyrl', display: 'Serbian (Cyrillic)' },
  { locale: 'sr-Cyrl-BA', display: 'Serbian (Cyrillic, Bosnia and Herzegovina)' },
  { locale: 'sr-Cyrl-ME', display: 'Serbian (Cyrillic, Montenegro)' },
  { locale: 'sr-Cyrl-RS', display: 'Serbian (Cyrillic, Serbia)' },
  { locale: 'sr-Cyrl-XK', display: 'српски (Косово)' },
  { locale: 'sr-Latn', display: 'Serbian (Latin)' },
  { locale: 'sr-Latn-BA', display: 'Serbian (Latin, Bosnia & Herzegovina)' },
  { locale: 'sr-Latn-ME', display: 'Serbian (Latin, Montenegro)' },
  { locale: 'sr-Latn-RS', display: 'Serbian (Latin, Serbia)' },
  { locale: 'sr-Latn-XK', display: 'srpski (Kosovo)' },
  { locale: 'ss', display: 'Siswati' },
  { locale: 'ss-SZ', display: 'siSwati (eSwatini)' },
  { locale: 'ss-ZA', display: 'siSwati (South Africa)' },
  { locale: 'ssy', display: 'Saho' },
  { locale: 'ssy-ER', display: 'Saho (Eretria)' },
  { locale: 'st', display: 'Sesotho' },
  { locale: 'st-LS', display: 'Sesotho (Lesotho)' },
  { locale: 'st-ZA', display: 'Sesotho (South Africa)' },
  { locale: 'sv', display: 'Swedish' },
  { locale: 'sv-AX', display: 'svenska (Åland)' },
  { locale: 'sv-FI', display: 'Swedish (Finland)' },
  { locale: 'sv-SE', display: 'Swedish (Sweden)' },
  { locale: 'sw', display: 'Kiswahili' },
  { locale: 'sw-CD', display: 'Kiswahili (Jamhuri ya Kidemokrasia ya Kongo)' },
  { locale: 'sw-KE', display: 'Kiswahili (Kenya)' },
  { locale: 'sw-TZ', display: 'Kiswahili (Tanzania)' },
  { locale: 'sw-UG', display: 'Kiswahili (Uganda)' },
  { locale: 'syr', display: 'Syriac' },
  { locale: 'syr-SY', display: 'Syriac (Syria)' },
  { locale: 'ta', display: 'Tamil' },
  { locale: 'ta-IN', display: 'Tamil (India)' },
  { locale: 'ta-LK', display: 'Tamil (Sri Lanka)' },
  { locale: 'ta-MY', display: 'தமிழ் (மலேசியா)' },
  { locale: 'ta-SG', display: 'தமிழ் (சிங்கப்பூர்)' },
  { locale: 'te', display: 'Telugu' },
  { locale: 'te-IN', display: 'Telugu (India)' },
  { locale: 'teo', display: 'Kiteso' },
  { locale: 'teo-KE', display: 'Kiteso (Kenia)' },
  { locale: 'teo-UG', display: 'Kiteso (Uganda)' },
  { locale: 'tg', display: 'Tajik' },
  { locale: 'tg-Cyrl', display: 'Tajik (Cyrillic)' },
  { locale: 'tg-Cyrl-TJ', display: 'Tajik (Cyrillic, Tajikistan)' },
  { locale: 'th', display: 'Thai' },
  { locale: 'th-TH', display: 'Thai (Thailand)' },
  { locale: 'ti', display: 'Tigrinya' },
  { locale: 'ti-ER', display: 'Tigrinya (Eritrea)' },
  { locale: 'ti-ET', display: 'Tigrinya (Ethiopia)' },
  { locale: 'tig', display: 'ትግረ' },
  { locale: 'tig-ER', display: 'ትግረ (ኤርትራ)' },
  { locale: 'tk', display: 'Turkmen' },
  { locale: 'tk-TM', display: 'Turkmen (Turkmenistan)' },
  { locale: 'tn', display: 'Setswana' },
  { locale: 'tn-BW', display: 'Setswana (Botswana)' },
  { locale: 'tn-ZA', display: 'Setswana (South Africa)' },
  { locale: 'to', display: 'lea fakatonga' },
  { locale: 'to-TO', display: 'lea fakatonga (Tonga)' },
  { locale: 'tr', display: 'Turkish' },
  { locale: 'tr-CY', display: 'Türkçe (Kıbrıs)' },
  { locale: 'tr-TR', display: 'Turkish (Turkey)' },
  { locale: 'ts', display: 'Xitsonga' },
  { locale: 'ts-ZA', display: 'Xitsonga (South Africa)' },
  { locale: 'tt', display: 'Tatar' },
  { locale: 'tt-RU', display: 'Tatar (Russia)' },
  { locale: 'twq', display: 'Tasawaq senni' },
  { locale: 'twq-NE', display: 'Tasawaq senni (Nižer)' },
  { locale: 'tzm', display: 'Central Atlas Tamazight' },
  { locale: 'tzm-Arab', display: 'أطلس المركزية التامازيتية' },
  { locale: 'tzm-Arab-MA', display: 'Central Atlas Tamazight (Arabic, Morocco)' },
  { locale: 'tzm-Latn', display: 'Central Atlas Tamazight (Latin)' },
  { locale: 'tzm-Latn-DZ', display: 'Central Atlas Tamazight (Latin, Algeria)' },
  { locale: 'tzm-Latn-MA', display: 'Tamaziɣt n laṭlaṣ (Meṛṛuk)' },
  { locale: 'tzm-Tfng', display: 'Central Atlas Tamazight (Tifinagh)' },
  { locale: 'tzm-Tfng-MA', display: 'Central Atlas Tamazight (Tifinagh, Morocco)' },
  { locale: 'ug', display: 'Uyghur' },
  { locale: 'ug-CN', display: 'Uyghur (China)' },
  { locale: 'uk', display: 'Ukrainian' },
  { locale: 'uk-UA', display: 'Ukrainian (Ukraine)' },
  { locale: 'ur', display: 'Urdu' },
  { locale: 'ur-IN', display: 'Urdu (India)' },
  { locale: 'ur-PK', display: 'Urdu (Pakistan)' },
  { locale: 'uz', display: 'Uzbek' },
  { locale: 'uz-Arab', display: 'اوزبیک' },
  { locale: 'uz-Arab-AF', display: 'اوزبیک (افغانستان)' },
  { locale: 'uz-Cyrl', display: 'Uzbek (Cyrillic)' },
  { locale: 'uz-Cyrl-UZ', display: 'Uzbek (Cyrillic, Uzbekistan)' },
  { locale: 'uz-Latn', display: 'Uzbek (Latin)' },
  { locale: 'uz-Latn-UZ', display: 'Uzbek (Latin, Uzbekistan)' },
  { locale: 'vai', display: 'ꕙꔤ' },
  { locale: 'vai-Latn', display: 'Vai' },
  { locale: 'vai-Latn-LR', display: 'Vai (Laibhiya)' },
  { locale: 'vai-Vaii', display: 'ꕙꔤ' },
  { locale: 'vai-Vaii-LR', display: 'ꕙꔤ (ꕞꔤꔫꕩ)' },
  { locale: 've', display: 'Venda' },
  { locale: 've-ZA', display: 'Venda (South Africa)' },
  { locale: 'vi', display: 'Vietnamese' },
  { locale: 'vi-VN', display: 'Vietnamese (Vietnam)' },
  { locale: 'vo', display: 'Volapük' },
  { locale: 'vo-001', display: 'Volapük (World)' },
  { locale: 'vun', display: 'Kyivunjo' },
  { locale: 'vun-TZ', display: 'Kyivunjo (Tanzania)' },
  { locale: 'wae', display: 'Walser' },
  { locale: 'wae-CH', display: 'Walser (Schwiz)' },
  { locale: 'wal', display: 'ወላይታቱ' },
  { locale: 'wal-ET', display: 'ወላይታቱ (ኢትዮጵያ)' },
  { locale: 'wo', display: 'Wolof' },
  { locale: 'wo-SN', display: 'Wolof (Senegal)' },
  { locale: 'xh', display: 'isiXhosa' },
  { locale: 'xh-ZA', display: 'isiXhosa (South Africa)' },
  { locale: 'xog', display: 'Olusoga' },
  { locale: 'xog-UG', display: 'Olusoga (Yuganda)' },
  { locale: 'yav', display: 'nuasue' },
  { locale: 'yav-CM', display: 'nuasue (Kemelún)' },
  { locale: 'yi', display: 'Yiddish' },
  { locale: 'yi-001', display: 'Yiddish (World)' },
  { locale: 'yo', display: 'Yoruba' },
  { locale: 'yo-BJ', display: 'Èdè Yorùbá (Orílɛ́ède Bɛ̀nɛ̀)' },
  { locale: 'yo-NG', display: 'Yoruba (Nigeria)' },
  { locale: 'zgh', display: 'ⵜⴰⵎⴰⵣⵉⵖⵜ' },
  { locale: 'zgh-Tfng', display: 'ⵜⴰⵎⴰⵣⵉⵖⵜ' },
  { locale: 'zgh-Tfng-MA', display: 'ⵜⴰⵎⴰⵣⵉⵖⵜ (ⵍⵎⵖⵔⵉⴱ)' },
  { locale: 'zh', display: 'Chinese' },
  { locale: 'zh-CN', display: 'Chinese (Simplified, China)' },
  { locale: 'zh-Hans', display: 'Chinese (Simplified)' },
  { locale: 'zh-Hans-HK', display: '中文 (香港特别行政区)' },
  { locale: 'zh-Hans-MO', display: '中文 (澳门特别行政区)' },
  { locale: 'zh-Hant', display: 'Chinese (Traditional)' },
  { locale: 'zh-HK', display: 'Chinese (Traditional, Hong Kong SAR)' },
  { locale: 'zh-MO', display: 'Chinese (Traditional, Macao SAR)' },
  { locale: 'zh-SG', display: 'Chinese (Simplified, Singapore)' },
  { locale: 'zh-TW', display: 'Chinese (Traditional, Taiwan)' },
  { locale: 'zu', display: 'isiZulu' },
  { locale: 'zu-ZA', display: 'isiZulu (South Africa)' },
];

export default localeMappings;
